










































































































import { Component, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import CardTitle from '@/components/common/CardTitle.vue';
import FactorImportanceChart from '@/components/chart/FactorImportantceChart.vue';
import { CHART_TYPES, CHART_TYPE_NAMES } from '@/utils/ChartTypes';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import Modelling from '@/store/modules/Modelling';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import { Viewpoint } from '@/api/model/Viewpoint';
import Scoring from '@/store/modules/Scoring';

const workspaceOptions = getModule(WorkspaceOptions);
const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const viewpointModule = getModule(Viewpoints);
const choiceModule = getModule(Choices);

@Component({
    name: 'WeightFactorImportanceChart',
    components: {
        FactorImportanceChart,
        CardTitle,
    },
})
export default class WeightFactorImportanceChart extends Vue {
    @Prop({ default: '', type: String })
    factorId!: string;

    @Prop({ default: '', type: String })
    currentViewpointId!: string;

    private items = CHART_TYPES;
    private CHART_TYPE_NAMES = CHART_TYPE_NAMES;
    private isLoading = false;
    private tooltipShow = false;
    private open = false;
    private task: any;

    private chartData = {
        series: [],
        categories: [],
        title: ''
    };

    get barChartData() {
        return this.chartData;
    }

    get viewpointId() {
        return viewpointModule.activeViewpointId;
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    get activeViewpointId() {
        return viewpointModule.activeViewpointId;
    }

    get isBarChartHorizontal() {
        return workspaceOptions.isFactorImportanceChartHorizontal;
    }

    set isBarChartHorizontal(isHorizontal: boolean) {
        workspaceOptions.setIsFactorImportanceChartHorizontal(isHorizontal);
    }

    get selectedChoices() {
        return choiceModule.unfilteredChoicesList;
    }

    get viewpoint() {
        if (this.activeViewpointId) {
            return viewpointModule.unfilteredViewpointsMap[this.activeViewpointId] as Viewpoint;
        } else {
            return null;
        }
    }

    get selectedViewpointIds() {
        return viewpointModule.selectedViewpointIds;
    }

    private chartDataDelay() {
        this.task = setTimeout(() => {this.getChartData() }, 800);
    }

    private cancelTask() {
        clearTimeout(this.task);
    }
    private async getChartData() {
        try {
            if (this.decisionId && this.viewpointId && this.factorId) {
                this.isLoading = true;
                const factor = this.factors[this.factorId];

                const viewpointId = this.currentViewpointId;
                const viewpointIds = this.selectedViewpointIds;
                //this chart only displays one viewpoint's importances at a time
                const res = await getModule(Scoring).getFactorImportanceChart({decisionId: this.decisionId, viewpointId: viewpointId, viewpointIds: [viewpointId], factorIds: factor.childrenIds});

                this.chartData = res;
            }
        } catch (error) {
            console.log(error);
        }
        this.isLoading = false;
    }
}
